<div [class]="'bottomview fixed ' + extraClass">
    <div class="bodybottomview">
        <ng-content></ng-content>
    </div>
</div>